/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gnoment, Gnoment } from 'shared-ui/gnoment';
import get from 'lodash/get';
import { Button, Icon } from 'sarsaparilla';
import { dateSelectionProps } from '../../props/multi-division/DateSelection';
import PreferredDatesItem from './PreferredDatesItem';
import {
    hasLotteryPreferenceDateDivisionDuration,
    hasLotteryPreferenceDateDivisionGroupSize,
    hasLotteryPreferenceDateDivisionMaxGroupSizeOnly,
    getLotteryPreferenceType,
    readRuleValue,
    getValidationErrorStyle,
} from '../../utils/utilsNew';
import {
    IS_CHOICE_DATE_EMPTY,
    IS_DIVISION_EMPTY,
    IS_GROUP_MAX_EMPTY,
    IS_DURATION_EMPTY,
    IS_CHOICE_START_DATE_EMPTY,
    IS_CHOICE_END_DATE_EMPTY,
} from '../../constants';

export function getAvailability(day, selections, index, allowSameDate) {
    const currentSelection = selections[index];
    let value = false;

    if (allowSameDate) {
        return false;
    }

    selections.forEach((selection, i) => {
        if (
            i !== index &&
            currentSelection.division_id === selection.division_id &&
            selection.preferred_date
        ) {
            value = gnoment(selection.preferred_date).utc().diff(day) === 0;
        }
    });
    return value;
}

export class PreferredDatesList extends Component {
    static propTypes = {
        permit: PropTypes.shape({}),
        divisions: PropTypes.shape({}),
        seasonStart: PropTypes.instanceOf(Gnoment),
        selections: PropTypes.arrayOf(dateSelectionProps),
        onChange: PropTypes.func.isRequired,
        onAdd: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        allowMore: PropTypes.bool,
        allowSameDate: PropTypes.bool,
        isCommercialUser: PropTypes.bool,
    };

    static defaultProps = {
        allowMore: true,
    };
    render() {
        const enableLengthOfStaySelect = hasLotteryPreferenceDateDivisionDuration(
            this.props.permit,
            undefined
        );
        const enableMinMaxGroupSelect = hasLotteryPreferenceDateDivisionGroupSize(
            this.props.permit,
            undefined
        );
        const enableMaxOnlyGroupSelect = hasLotteryPreferenceDateDivisionMaxGroupSizeOnly(
            this.props.permit,
            undefined
        );

        const lotteryPreferenceType = getLotteryPreferenceType(
            this.props.permit,
            undefined
        );
        const validations = get(this.props, 'validation', {});
        const maxGroupSize = readRuleValue('MaxGroupSize', this.props.permit.rules);
        return (
            <div className="per-preferred-dates-list">
                <div className="per-form-group">
                    {this.props.selections.map((selection, idx) => {
                        const validationErrors = {
                            divisionRequired: getValidationErrorStyle(
                                validations,
                                `Choice #${idx + 1}: ${IS_DIVISION_EMPTY}`
                            ),
                            choiceRequired: getValidationErrorStyle(
                                validations,
                                `Choice #${idx + 1}: ${IS_CHOICE_DATE_EMPTY}`
                            ),
                            groupMaxRequired: getValidationErrorStyle(
                                validations,
                                `Choice #${idx + 1}: ${IS_GROUP_MAX_EMPTY}`
                            ),
                            lengthOfStayRequired: getValidationErrorStyle(
                                validations,
                                `Choice #${idx + 1}: ${IS_DURATION_EMPTY}`
                            ),
                            dateRangeRequired:
                                getValidationErrorStyle(
                                    validations,
                                    `Choice #${idx + 1}: ${IS_CHOICE_END_DATE_EMPTY}`
                                ) ||
                                getValidationErrorStyle(
                                    validations,
                                    `Choice #${idx + 1}: ${IS_CHOICE_START_DATE_EMPTY}`
                                ),
                        };
                        return (
                            <PreferredDatesItem
                                blockFilter={(day) =>
                                    getAvailability(
                                        day,
                                        this.props.selections,
                                        idx,
                                        this.props.allowSameDate
                                    )
                                }
                                divisions={this.props.divisions}
                                seasonStart={this.props.seasonStart}
                                selection={selection}
                                onChange={(value) => this.props.onChange(idx, value)}
                                onRemove={this.props.onRemove}
                                index={idx}
                                key={`date-${selection.id}`}
                                enableLengthOfStaySelect={enableLengthOfStaySelect}
                                lengthOfStayLimit={
                                    enableLengthOfStaySelect
                                        ? parseInt(
                                              readRuleValue(
                                                  'StayLimit',
                                                  this.props.permit.rules,
                                                  undefined
                                              ),
                                              10
                                          ) /
                                          (24 * 60 * 60)
                                        : 0
                                }
                                enableMinMaxGroupSelect={enableMinMaxGroupSelect}
                                enableMaxOnlyGroupSelect={enableMaxOnlyGroupSelect}
                                maxGroupSize={maxGroupSize}
                                validationErrors={validationErrors}
                                lotteryPreferenceType={lotteryPreferenceType}
                                isCommercialUser={this.props.isCommercialUser}
                            />
                        );
                    })}
                </div>
                <div className="rec-form-item-wrap">
                    <Button
                        appearance="link"
                        iconBeforeElement={<Icon iconName="add-circle" />}
                        onClick={this.props.onAdd}
                        isDisabled={!this.props.allowMore}
                        className="addAnotherChoiceLink"
                    >
                        Add another choice
                    </Button>
                </div>
            </div>
        );
    }
}

export default PreferredDatesList;
